import React, { useCallback } from 'react';
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';

import { PageErrorUi, UiKit } from 'components';
import Loader from './Loader';
import { ProductsSearchTable } from 'views/Configure/ReturnManagement/ReturnWindow/pages/ProductSkuExceptions/pages/Config/components';
import { useSeriesFetch } from 'utils/hooks';
import { useProductReturnWindowConfig } from '../../context';
import { createProductsData } from 'views/Configure/ReturnManagement/ReturnWindow/pages/ProductSkuExceptions/pages/Config/methods';
import { getProductVariantIds } from '../../utils';

export default function ProductVariants() {
  const {
    mode,
    initialData,
    windowId,
    onChange,
    onSetInitialProducts
  } = useProductReturnWindowConfig();

  const { isError, isLoading, fetchData } = useSeriesFetch(
    [
      {
        dataKey: 'productVariants',
        apiKey: 'productVaraints.post',
        method: 'POST',
        payload: {
          variant_ids: initialData.product_variants,
          out_of_stock_variants: true,
          is_deleted: true
        },
        onTransform: data => (_isArray(data) ? data : [])
      },
      {
        dataKey: 'products',
        apiKey: 'products.getAll',
        method: 'POST',
        payload(aggregateData) {
          const productVariants = _get(aggregateData, 'productVariants', []);
          const productIds = productVariants.map(productVariant => {
            return _get(productVariant, 'product.id');
          });
          return { ids: [...new Set(productIds)], page_size: 10000 };
        }
      }
    ],
    {
      loadOnMount: mode === 'edit',
      errorMessage: 'Unable to load the products at the moment.',
      onTransform: data => createProductsData(data),
      onSuccess: products => onSetInitialProducts(products)
    }
  );

  const onProductsChange = useCallback(
    products => {
      onChange({
        products,
        product_variants: getProductVariantIds(products)
      });
    },
    [onChange]
  );

  return (
    <PageErrorUi
      isError={isError}
      onReload={fetchData}
      msg="Unable to load the products at the moment."
    >
      <Loader isLoading={isLoading}>
        <UiKit.Flex direction="column">
          <UiKit.Text size="lg" weight="bold">
            Select the SKU's you want to include
          </UiKit.Text>
          <ProductsSearchTable
            windowId={windowId}
            pageSize={10}
            data={initialData.products || []}
            onDataChange={onProductsChange}
          />
        </UiKit.Flex>
      </Loader>
    </PageErrorUi>
  );
}
